import api from './api'
export default {
    get(parms) {
      // return api.get('files?type='+parms.type+'&id='+parms.id)
      return api.get('summary',{
        params: parms
        })
    },
    postInfo(parms) {
      return api.post('company_info',parms)
    }
    
  }